import { RouteRecordRaw } from 'vue-router'

export const personsRoutes: RouteRecordRaw[] = [
  {
    path: '/persons/:personId',
    name: 'person',
    redirect: to => {
      return `member/${to.params.personId}/pillars`
    }
  }
]
